<nav class="breadcrumbs" aria-label="breadcrumb">
  <ul class="breadcrumbs__list">
    <li
      *ngFor="let item of items; let last = last"
      [class.active]="last"
      class="breadcrumbs__item"
    >
      <ng-container *ngIf="!last">
        <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams">{{item.title}}</a>
        <a *ngIf="item.href" [href]="item.href">{{item.title}}</a>
      </ng-container>
      <span *ngIf="last">{{item.title}}</span>
    </li>
  </ul>
</nav>
